module.exports = __webpack_public_path__ + "img/c03.6f7d46f4.png";